import moment from 'moment';

export const GetFormattedDate = (DateInSeconds) => {
  const date = new Date(DateInSeconds);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  return (
    `${day}/${month}/${year}`
  );
};

export const GetCurrentFormattedDate = () => {
  const date = new Date();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  return (
    `${day}/${month}/${year}`
  );
};

export const getAge = (dateString) => {
  const b = moment.unix(dateString);
  const a = moment();

  const years = a.diff(b, 'year');
  b.add(years, 'years');

  const months = a.diff(b, 'months');
  b.add(months, 'months');

  return `${years} years ${months} months `;
};
